import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { rememberLeagueFromPath } from '../utils/lastLeague';

/** Persists the last opened map path for the Map nav item. */
export default function LeaguePathRemember() {
    const { pathname } = useLocation();
    useEffect(() => {
        rememberLeagueFromPath(pathname);
    }, [pathname]);
    return null;
}
